import React from 'react'
import { View, TouchableOpacity, Text } from 'react-native'
import styles from './styles'
import Toast from 'react-native-tiny-toast'

const ButtonConfirm = props => {
  const { text, disabled, onPress, msgDisabled } = props

  const onPressLocal = () => {
    props.onPress()
  }

  return (
    <View style={styles.containerButton}>
      <TouchableOpacity
        activeOpacity={disabled ? 1 : 0.2}
        style={disabled ? styles.buttonDisabled : styles.button}
        onPress={
          disabled
            ? () => {
                Toast.show(msgDisabled, {
                  position: 50,
                })
              }
            : onPressLocal
        }
      >
        <Text style={disabled ? styles.buttonTextDisabled : styles.buttonText}>
          {text}
        </Text>
      </TouchableOpacity>
    </View>
  )
}

export default ButtonConfirm
